/* eslint-disable dot-notation */
/* eslint-disable no-console */
import { businessActivity } from '../containers/actions/admin_actions';

export const UserActivity = async (body) =>
{
	try
	{
		const res = await businessActivity(body);

		if (res?.status)
		{
			console.log('Activity logged successfully');
		}
		else
		{
			console.log('Error logging activity');
		}
	}
	catch (error)
	{
		console.log('Error:', error);
	}
};
